import axiosInstance from "@/api/axios";

export const getDashboardPrompts = async (body?: object) => {
  try {
    const response = await axiosInstance({
      method: "GET",
      url: "/odoo/api/v1/ai/prompts",
      data: body ?? {},
    });
    console.log("response", response);
    return response.data;
  } catch (err) {
    console.log("err", err);
  }
};
